import { store } from "../store/store";
import type { RootState } from "../store/store";
import { setAppBackground, showAppLoader } from "../store/slice/uiPropsSlice";
import { clearAppSelections, clearFieldByName } from "../services/qlikSelectionService";
import { PAGES, QLIK_APP_REF } from "../constants";

let isFirstLoad = true;
let previousRoute: string | null = null;

export async function routeLoader({ request }: { request: Request }): Promise<void | null> {
    const dispatch = store.dispatch;
    dispatch(showAppLoader(true));
    const url = new URL(request.url);
    const currentPathSegment = url.pathname.split("/").filter(Boolean).pop() ?? "";

    const getState = (): RootState => store.getState();
    
    const to = currentPathSegment; // Current route
    const from = previousRoute || ""; // Previous route (or empty string if none)
    const toAppRef = PAGES[to]?.appRef || "";
    const fromAppRef = PAGES[from]?.appRef || "";

    //Setting background based on page config
    dispatch(setAppBackground(PAGES[to]?.useAppBackground ?? true));
    
    if (isFirstLoad) {
        isFirstLoad = false;
        previousRoute = currentPathSegment;
        dispatch(showAppLoader(false));
        return null;
    }

    if (PAGES[from].fieldsToClear && PAGES[from].fieldsToClear.length > 0) {
        for (const field of PAGES[from].fieldsToClear) {
            await clearFieldByName(fromAppRef, field);
        }
    }

    //Clearing app selections everytime component mounts (on page load / route change)
    await clearAppSelections(fromAppRef);


    // dispatch(showAppLoader(false));
    // Update the previous route
    previousRoute = toAppRef.length > 0 ? to : previousRoute;
    dispatch(showAppLoader(false));
    return null;
}

export default { routeLoader };